// extracted by mini-css-extract-plugin
export default {"advicesPill":"FinalAdvice_advicesPill__zcyvV","icon":"FinalAdvice_icon__e8ZQG","advice":"FinalAdvice_advice__TLIh2"};